@if (visible()) {
  <div class="im-connection-banner-shell">
    <paper-banner tone="warning" [compact]="true" ariaLive="polite">
      <span class="paper-connection-banner__pulse" aria-hidden="true"></span>
    <span class="paper-connection-banner__copy">
      <strong>{{ 'shared.paper_connection_banner.backend_unreachable' | transloco }}</strong>
      <span class="paper-connection-banner__hint">
        {{ 'shared.paper_connection_banner.we_re_retrying_your_work_is' | transloco }}
      </span>
    </span>
      <paper-button
        intent="ghost"
        size="xs"
        icon="refresh"
        [loading]="retrying()"
        [disabled]="retrying()"
        (click)="retryNow()">
        {{ retrying() ? 'Checking' : 'Retry now' }}
      </paper-button>
    </paper-banner>
  </div>
}
